<template lang="pug">
	.play-button.flex-row.space
		a(@click="togglePlaying")
			.playing-state
				i.fa(:class="[isPlaying ? 'fa-pause' : 'fa-play']")
		.caption {{isPlaying && playingCaption ? playingCaption : caption}}
</template>

<script>
	import $ from 'jquery';

	export default {
		translationCategory: 'audioPlayer.PlayButton',
		name: 'play-button',
		props: ['playState', 'caption', 'playingCaption'],
		data() {
			return {
				isPlaying: this.playState
			};
		},
		watch: {
			isPlaying(v) {
				$(this.$el).find('.playing-state').html(v ? '<i class="fas fa-pause"/>' : '<i class="fas fa-play"/>');
			},
			playState(v) {
				this.isPlaying = v;
			}
		},
		methods: {
			togglePlaying() {
				this.isPlaying = !this.isPlaying;
				this.$emit('change', this.isPlaying);
			}
		}
	};
</script>
<style lang='scss'>
	.play-button {
		align-items: center;

		> .caption {
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}
</style>
